import { render } from "./ProductOffering.vue?vue&type=template&id=0ade0cb6"
import script from "./ProductOffering.vue?vue&type=script&lang=js"
export * from "./ProductOffering.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__